import { Box, Typography } from '@mui/material';
import { WordIntroExercise } from '../../mockLessonContent';
import { BLUE, cardSx, INTER, NAVY, POPPINS, SLATE, SURFACE_SOFT } from '../../studentStyles';
import AudioPlayButton from '../AudioPlayButton';
import ExerciseLabel from './ExerciseLabel';

// "Dialog w/ Character Listen" — a new word with its example sentence.
export default function WordIntroExerciseCard({ exercise }: { exercise: WordIntroExercise }) {
    return (
        <Box>
            <ExerciseLabel>NEW WORD</ExerciseLabel>
            <Box sx={{ ...cardSx, p: 3, textAlign: 'center' }}>
                <Box sx={{
                    width: 96, height: 96, borderRadius: '24px', mx: 'auto',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    backgroundColor: `${BLUE}14`,
                }}>
                    <Typography sx={{ fontSize: 48, lineHeight: 1 }}>{exercise.emoji}</Typography>
                </Box>
                <Typography sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 40, color: NAVY, mt: 2, lineHeight: 1.2 }}>
                    {exercise.hanzi}
                </Typography>
                <Typography sx={{ fontFamily: INTER, fontWeight: 600, fontSize: 16, color: BLUE, mt: 0.5 }}>
                    {exercise.pinyin}
                </Typography>
                <Typography sx={{ fontFamily: INTER, fontSize: 15, color: SLATE, mt: 0.5 }}>
                    {exercise.meaning}
                </Typography>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                    <AudioPlayButton ariaLabel={`Play audio for ${exercise.hanzi}`} size={48} />
                </Box>

                <Typography sx={{ fontFamily: INTER, fontWeight: 600, fontSize: 11, letterSpacing: '0.08em', color: SLATE, mt: 3, mb: 1, textAlign: 'left' }}>
                    EXAMPLE
                </Typography>
                <Box sx={{
                    p: 2, borderRadius: '16px', backgroundColor: SURFACE_SOFT,
                    display: 'flex', alignItems: 'center', gap: 1.5, textAlign: 'left',
                }}>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontFamily: POPPINS, fontWeight: 500, fontSize: 18, color: NAVY, lineHeight: 1.4 }}>
                            {exercise.example.hanzi}
                        </Typography>
                        <Typography sx={{ fontFamily: INTER, fontSize: 13, color: SLATE, mt: 0.25 }}>
                            {exercise.example.pinyin}
                        </Typography>
                        <Typography sx={{ fontFamily: INTER, fontSize: 13, color: SLATE, mt: 0.25 }}>
                            {exercise.example.english}
                        </Typography>
                    </Box>
                    <AudioPlayButton ariaLabel="Play example audio" size={32} />
                </Box>
            </Box>
        </Box>
    );
}
